<template>
  <div class="wrapper layout column fill-height">
    <v-select
      v-model="targetCountry"
      solo
      flat
      label="Country"
      hint="Please select a country to localize to"
      persistent-hint
      :items="$store.getters['product/getCountriesWithoutMaster']"
      @change="e => setTargetCountry(e)"
    />
    <v-spacer />
    <div v-show="targetCountry" class="layout meta align-center justify-center">
      <div class="pa-5">
        <div class="header" :style="subinfoStyle">{{ filteredCount }} new</div>
        <div class="support">
          slides from Master library selected
        </div>
        <div v-show="filteredCount === 0" class="subinfo layout" :style="subinfoStyle">
          <div>
            <v-icon size="22px" :style="subinfoStyle">
              {{ icons.alert }}
            </v-icon>
          </div>

          <div>
            All selected slides already exist in your local library (as a copy). Please go to your local
            library to adjust these slides or get the MASTER updates.
          </div>
        </div>
      </div>
      <v-divider vertical />
      <div class="pa-4">
        <div class="header">{{ originalCount }} existing</div>
        <div class="support">
          slides selected
        </div>
        <div class="subinfo">
          Those slides are already available in your local library - no additional copy needed.
        </div>
      </div>
    </div>
    <v-spacer />
    <div class="actions layout align-end justify-end">
      <core-button
        label="Select country"
        :disabled="!targetCountry || filteredCount === 0"
        flat
        not-rounded
        @click.stop="setState()"
      />
    </div>
  </div>
</template>

<script>
import localization from '@/mixins/localization-mixin';
import icons from '@/mixins/icons';

import CoreButton from '../../core/buttons/CoreButton';
import { mapState } from 'vuex';

export default {
  name: 'SelectTargetCountry',
  components: { CoreButton },
  mixins: [localization, icons],
  computed: {
    subinfoStyle() {
      return {
        color: this.filteredCount === 0 ? 'var(--salmon)' : ''
      };
    },
    ...mapState('localization', {
      originalCount: ({ localization }) => localization.slides.originalCount,
      filteredCount: ({ localization }) => localization.slides.filteredCount
    })
  },
  data() {
    return {
      targetCountry: null
    };
  }
};
</script>

<style scoped>
.meta {
  width: 100%;
  text-align: center;
}
.header {
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  font-weight: 500;
}
.support {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
}
.subinfo {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #b1b1b1;
}
</style>
